import { useMutation } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { axios } from 'configurations/axios';
import { IS3ListFilesResponse } from '../models/interfaces/IS3ListFilesResponse';

type ListS3FilesVariables = {
    path: string;
};

export const useListS3Files = () => {
    const { tenantConfig, jwt } = useSessionStore((state) => ({
        tenantConfig: state.tenantConfiguration,
        jwt: state.jwtToken,
    }));

    return useMutation<IS3ListFilesResponse, unknown, ListS3FilesVariables>(
        async ({ path }) => {
            const response = await axios.post<IResponseAPI<IS3ListFilesResponse>>(
                `${tenantConfig?.endpoints.queue}/Queue/S3Queue/ListFiles`,
                {
                    Path: path,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        }
    );
};
